import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosClient } from "redux/AxiosClient";

export const getAllAdhocJobsAsync = createAsyncThunk(
  "adhocjob/getAllAdhocJobs",
  async (payload, toolkit) => {
    const finalPayload = { ...payload, platform: "website" };
    return await AxiosClient(
      "GET",
      `/adhocjob/get-all`,
      [],
      toolkit,
      finalPayload
    );
  }
);

export const updateAdhocJobAdminStatusAsync = createAsyncThunk(
  "adhocjob/updateAdminStatus",
  async ({ id, adminStatus }, toolkit) => {
    return await AxiosClient(
      "PUT",
      `/adhocjob/update-admin-status/${id}`,
      { adminStatus },
      toolkit
    );
  }
);

export const getAdhocJobByJobIdAsync = createAsyncThunk(
  "job/ActivityViewByJobId",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/adhocjob/get-single-job?adhocJobId=${payload?.jobaActivityInfoId}&page=${payload?.page || 1
      }&limit=${payload?.limit || 10}`,
      [],
      toolkit
    );
  }
);

export const getAdhocJobCostAsync = createAsyncThunk(
  "adhocjob/getAdhocJobCost",
  async (payload, toolkit) => {
    return await AxiosClient(
      "GET",
      `/costreport/get-costs/${payload?.jobId}`,
      [],
      toolkit
    );
  }
);

export const updateAdhocJobTextValidationAsync = createAsyncThunk(
  "adhocjob/updateTextValidation",
  async (payload, toolkit) => {
    return await AxiosClient(
      "PUT",
      `/adhocjob/update-text-validation`,
      payload,
      toolkit
    );
  }
);